import { render, staticRenderFns } from "./bookingView.vue?vue&type=template&id=3c4256f5"
import script from "./bookingView.vue?vue&type=script&lang=js"
export * from "./bookingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports